import OtpAuthenticationComponent from './OtpAuthenticationContainer';

export default OtpAuthenticationComponent;
